import { Box, Heading } from '@99designs/emu';
import { FlexibleColumnFAQs } from '@99designs/marketing-ui';
import { formatFaqsFromAdditionalDetails } from '../FAQSection/FAQFormatter';
import type { FixedPriceProjectProductAdditionalDetail } from '../../types/Product';

type Props = {
    items: FixedPriceProjectProductAdditionalDetail[];
};

export function AdditionalCost({ items }: Props) {
    return (
        <>
            <Heading appearanceLevel={4} accessibilityLevel={2}>
                {__('Things that might cost more outside of this package')}
            </Heading>
            <Box display="flex" paddingY="2bu" flexDirection="column">
                <FlexibleColumnFAQs
                    onOpen={() => {
                        return true;
                    }}
                    faqSections={[formatFaqsFromAdditionalDetails(items)]}
                    iconType="upDown"
                />
            </Box>
        </>
    );
}
